module.exports = __webpack_public_path__ + "static/head-bg.e9c2a5f4.png";